module.exports = __webpack_public_path__ + "img/16m006-15.bfdbdb7c.jpg";